import type { PostInsightsData } from '@shared/dream-components';
import { createContext } from 'react';

import type { CookieValues, SetCookieOptions } from '~/hooks/useUtils/useCookies';
import type { Subscription } from '~/interfaces/subscriptions';

export type PageModalType = 'content_gate' | 'email_capture' | 'booking_modal' | null;

export interface PageContextType {
  cookies: CookieValues;
  setCookie: (options: SetCookieOptions) => void;
  removeCookie: (name: SetCookieOptions['name']) => void;
  cookiesSet?: boolean;
  visitToken?: string;
  referralId?: string;
  recaptchaSiteKey?: string;
  currentPath: string;
  subscription?: Subscription;
  openPageModalType: PageModalType;
  setOpenPageModalType: (type: PageModalType) => void;
  closeModalActionDispatched: boolean;
  setCloseModalActionDispatched: (value: boolean) => void;
  postsInsights: Record<string, PostInsightsData>;
  setPostsInsights: (data: Record<string, PostInsightsData>) => void;
}

export const PageContext = createContext<PageContextType | undefined>(undefined);
